import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";

interface IState {
  checkoutDetails: {
    event: string;
    eventData: Record<string, any>;
  } | null;
  isCheckoutStep: boolean;
}

interface IActions {
  setCheckoutDetails: (value: {
    event: string;
    eventData: Record<string, any>;
  }) => void;
  setIsCheckoutStep: (value: boolean) => void;
  reset: () => void;
}

const initState: IState = {
  checkoutDetails: null,
  isCheckoutStep: false,
};

export const usePurchaseSubscriptionStore = create<IState & IActions>(
  (set, _get) => ({
    ...initState,
    setCheckoutDetails: (checkoutDetails) => {
      if (checkoutDetails.event === "Checkout.Payment.Selection") {
        set({ isCheckoutStep: true });
      }
      set({ checkoutDetails });
    },
    setIsCheckoutStep: (isCheckoutStep) => set({ isCheckoutStep }),
    reset: () => set(initState),
  }),
);

export const usePurchaseSubscriptionStoreShallow = <U>(
  selector: (store: IState & IActions) => U,
) => {
  return usePurchaseSubscriptionStore(useShallow(selector));
};
